__turbopack_context__.v({
  "directionsLink": "MapView-module__LcnuIG__directionsLink",
  "error": "MapView-module__LcnuIG__error",
  "greyscale": "MapView-module__LcnuIG__greyscale",
  "iframe": "MapView-module__LcnuIG__iframe",
  "iframeWrap": "MapView-module__LcnuIG__iframeWrap",
  "info": "MapView-module__LcnuIG__info",
  "note": "MapView-module__LcnuIG__note",
  "osmLink": "MapView-module__LcnuIG__osmLink",
  "root": "MapView-module__LcnuIG__root",
});
